import React from "react"

import Template from "./Template"
import Markdown from "./Markdown"

export default ({ title, id }) => {
  const data = require(`../cms/${id}`)

  return (
    <Template title={title}>
      <Markdown raw={data.text} />
    </Template>
  )
}